import React, { useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next'
import configData from '../../../temp/config'
import ResultDetail from './ResultDetail';

const ResultLists = (props) => {
    const [resultdetailblkvisible, setResultdetailblkvisible] = useState(false)
    const[fetchdata, setFetchdata] = useState({
        title:'',
        href:'',
        ingredients:[],        
        thumbnail:'',
        shortdescription:'',
        keywordlink:''
    })
    /* Assign Variable for Pagination */
    const [currentPage, setCurrentPage] = useState(1)

    useEffect(() => {        
        setFetchdata(fetchdata => ({
            title: props.title,
            href: props.href,
            ingredients: props.ingredients,
            thumbnail: props.thumbnail,
            shortdescription: props.shortdescription,
            keywordlink: props.keywordlink
        }))        
    },[])

    const recipeDetail = (event, title) =>{
        event.preventDefault()
        setResultdetailblkvisible(!resultdetailblkvisible)
        props.detailblk(resultdetailblkvisible)
    }

    //Navigate to the page
    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber)
    }

    const { t } = props;

    return (  
        <>      
        <div className="resultlist">
            {
                fetchdata.thumbnail !== '' &&
                <div className="imgblk">
                    <a href={`${fetchdata.href.toLowerCase()}`}><img src={`${configData.sitecoreApiHost}${fetchdata.thumbnail}`} /></a>
                </div>
            }
            <div className="infolblk">
                <h4>
                    <a href={`${decodeURI(fetchdata.href.toLowerCase())}`}
                       //onClick={(e) => recipeDetail(e, fetchdata.title)}
                    >
                        {fetchdata.title}
                    </a>
                </h4>
                <p>{fetchdata.shortdescription}</p>
                {/* <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque cursus et velit nec tristique. Aenean lacinia urna elit, id placerat felis posuere et. Curabitur lobortis dapibus ligula aliquet tincidunt. Praesent blandit facilisis sapien, sed fermentum sapien congue at. Aenean eros tortor, posuere ut facilisis sit amet, ullamcorper eu tortor. Donec semper consectetur nibh sed vestibulum. Donec sem lacus, scelerisque nec mollis eu, posuere ac ligula. Sed fringilla molestie fringilla. Phasellus mollis malesuada velit, in porttitor orci ornare ut. Nulla dictum nulla eget lacus ultricies, id efficitur nisi fringilla. Nullam ullamcorper, nisi vitae blandit pellentesque, nisl tellus congue diam, ut condimentum sem augue nec augue. Aenean ligula ipsum, aliquet ut eros sed, finibus scelerisque urna.</p> */}
                <div className="keywordblk">
                    <p>
                        {t('RecipeFinder_Keyword')}
                        {
                            fetchdata.ingredients && fetchdata.ingredients.map((ingredient, index) => {
                                return <a href={`${fetchdata.keywordlink.toLowerCase()}?keyword=${ingredient.trim().toLowerCase()}`} key={index}>{ingredient.trim()}{fetchdata.ingredients.length !== index+1 && ',' }</a>
                            })
                        }
                    </p>
                </div>
            </div>
        </div>        
        </>
    );
};

export default withTranslation()(ResultLists);